/**
 * SDA-263 request fulfillment statuses — labels exactly as the client
 * specified. Single source of truth for the dashboard badges (read-only)
 * and the booking-page selects (the only edit surface), so the copy can't
 * drift between the two.
 */

export const MARKETING_STATUS_OPTIONS = [
  { value: 'waiting_studio_material', label: 'Waiting for studio material' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'complete', label: 'Complete' },
] as const;

export const GROUP_TICKET_STATUS_OPTIONS = [
  { value: 'new', label: 'New' },
  { value: 'waiting_ticket_order', label: 'Waiting on ticket order' },
  { value: 'complete', label: 'Complete' },
] as const;

/**
 * Flat value→label map across both categories for the dashboard badge, which
 * renders the worker's unified `request_status` without knowing the category.
 * 'complete' rows are filtered out server-side, so that label never renders
 * on the dashboard.
 */
export const REQUEST_STATUS_LABELS: Record<string, string> = Object.fromEntries(
  [...MARKETING_STATUS_OPTIONS, ...GROUP_TICKET_STATUS_OPTIONS].map((o) => [o.value, o.label]),
);
